import React from 'react';
import Header from './components/Header'
import Footer from './components/Footer'
import Main from './components/Main'
import './css/app.css'
import './css/font_styles.css'



export default function App(){

    return(
        <>
            <Header />
            <Main />
            <Footer />
        </>
    )
}